// evidencetype_edit.js

$(document).ready(function () {
    initForms();
});

function initForms() {
    // Enable "diry form" checking on the form
    $('form').areYouSure();
}